import { render, staticRenderFns } from "./DashboardContent.vue?vue&type=template&id=5088fdd4&"
import script from "./DashboardContent.vue?vue&type=script&lang=js&"
export * from "./DashboardContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports